export class PaymentRequestData {
  constructor(
    country,
    currency,
    total,
    requestPayerName,
    requestPayerEmail
  ) {
    this.country = country;
    this.currency = currency;
    this.total = total;
    this.requestPayerName = requestPayerName;
    this.requestPayerEmail = requestPayerEmail;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new PaymentRequestData(
        input.country,
        input.currency,
        input.total,
        input.requestPayerName,
        input.requestPayerEmail
      )
    }

    return new PaymentRequestData();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => PaymentRequestData.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [PaymentRequestData.fromApiObject(input)];
    }

    return [];
  }
}